var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'business-data-chart',
        {
            pc: _vm.isPc
        }
    ]},[(_vm.dataSource)?_c('BusinessDataChart',{attrs:{"dataSource":_vm.dataSource,"theme":_vm.theme,"lang":_vm.lang}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }